<template>
  <v-select
      v-model="value"
      :items="items"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {ProductStatus} from "@/modules/redactor/models/product/ProductStatus";

export default {
  name: "r-product-status",
  props: {
    model: VueTypes.instanceOf(ProductStatus),
    label: VueTypes.string.def("Product Status:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    items() {
      return ProductStatus.getValues();
    }
  }
}

</script>